// Lógica pura da aba Eva (resolução de período/cidade filtrados, conversão de
// insights da API e normalização dos chats), extraída de index.jsx para ser
// testada sem redux/serviços de rede.

// Resolve o período correto considerando o filtro de cidade (mesma lógica
// usada em buildParams): quando uma cidade específica está selecionada, usa
// o período equivalente daquela cidade (mesma start_date do período geral),
// se existir; senão cai no período selecionado puro.
export function resolveSelectedPeriod({ period, city, periods }) {
  if (!city || city === "todas") return period;
  const geralPeriod = (periods || []).find(
    (p) => p.name === period && (!p.city || p.city === ""),
  );
  if (geralPeriod) {
    const cityPeriod = (periods || []).find(
      (p) => p.city === city && p.start_date === geralPeriod.start_date,
    );
    if (cityPeriod) return cityPeriod.name;
  }
  return period;
}

export function resolveSelectedCity(filtersState) {
  return filtersState.city === "todas" ? "" : filtersState.city || "";
}

// Converte os insights crus da API (category/title/description/action) para
// o formato esperado pelo EvaInsights (tipo/titulo/corpo/acao/prio).
export function convertInsightsToRender(items) {
  if (!Array.isArray(items)) return [];
  return items.map((it) => {
    const prioMatch = (it.priority || "").match(/\d+/);
    const prio = prioMatch ? Number(prioMatch[0]) : null;
    const tipo = (it.category || "").toLowerCase();
    return {
      tipo,
      titulo: it.title || it.titulo || "",
      corpo: it.description || it.corpo || "",
      acao: it.action || it.acao || "",
      prio,
    };
  });
}

// Normaliza os chats vindos do redux/API pro shape usado pela UI (EvaChat/
// EvaChatHistory): id/title/createdAt (timestamp)/messages (role/content).
// Descarta chats com created_at inválido.
export function deriveApiChats(chats) {
  return (chats || [])
    .map((c) => ({
      id: c.id,
      title: c.title,
      createdAt: new Date(c.created_at || c.createdAt).getTime(),
      messages: (c.messages || c.mensagens || []).map((m) => ({
        id: m.id,
        createdAt: m.created_at ? new Date(m.created_at).getTime() : m.createdAt,
        role: m.role || (m.sender === "system" ? "assistant" : m.sender),
        content: m.content || m.message,
      })),
    }))
    .filter((chat) => !Number.isNaN(chat.createdAt));
}

// Mescla chats pendentes (criados nesta sessão, ainda não refletidos na API)
// com os já carregados, do mais recente para o mais antigo.
export function mergeAndSortChats(pendingChats, apiChats) {
  return [...(pendingChats || []), ...(apiChats || [])].sort(
    (a, b) => b.createdAt - a.createdAt,
  );
}
